import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
import { ShieldCheck, Check } from 'lucide-react';
export function OfferSection() {
  return <section className="py-24 bg-rose-50 relative overflow-hidden" data-id="element-131">
      {/* Decorative background */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-white rounded-full blur-3xl opacity-60 pointer-events-none" data-id="element-132"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-133">
        <motion.div className="bg-white rounded-[2.5rem] p-8 md:p-12 shadow-2xl border border-rose-100 text-center" initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} data-id="element-134">
          <div className="inline-block bg-rose-100 text-rose-700 font-bold px-4 py-1.5 rounded-full text-sm uppercase tracking-wider mb-8" data-id="element-135">
            Oferta Especial
          </div>

          <h2 className="text-3xl md:text-4xl font-playfair font-bold mb-4 text-dark" data-id="element-136">
            Empezá tu negocio hoy mismo
          </h2>

          <p className="text-gray-500 mb-8 max-w-xl mx-auto" data-id="element-137">
            El valor total de todo esto podría ser fácilmente{' '}
            <span className="line-through" data-id="element-138">$30.000 ARS</span>, considerando lo
            completo y práctico que es.
          </p>

          <div className="mb-10" data-id="element-139">
            <p className="text-sm font-bold text-rose-500 uppercase tracking-widest mb-2" data-id="element-140">
              Pero hoy podés acceder por solo:
            </p>
            <div className="flex items-center justify-center gap-2" data-id="element-141">
              <span className="text-5xl md:text-7xl font-bold text-dark tracking-tight" data-id="element-142">
                $14.999
              </span>
              <span className="text-2xl text-gray-400 font-medium mt-4" data-id="element-143">
                ARS
              </span>
            </div>
          </div>

          <div className="flex flex-col items-center gap-4 mb-10" data-id="element-144">
            <ul className="text-left space-y-3 mb-6" data-id="element-145">
              <li className="flex items-center gap-3 text-dark-light font-medium" data-id="element-146">
                <div className="bg-green-100 p-1 rounded-full" data-id="element-147">
                  <Check className="w-4 h-4 text-green-600" data-id="element-148" />
                </div>
                Acceso inmediato
              </li>
              <li className="flex items-center gap-3 text-dark-light font-medium" data-id="element-149">
                <div className="bg-green-100 p-1 rounded-full" data-id="element-150">
                  <Check className="w-4 h-4 text-green-600" data-id="element-151" />
                </div>
                Descarga digital
              </li>
              <li className="flex items-center gap-3 text-dark-light font-medium" data-id="element-152">
                <div className="bg-green-100 p-1 rounded-full" data-id="element-153">
                  <Check className="w-4 h-4 text-green-600" data-id="element-154" />
                </div>
                Todos los bonos incluidos
              </li>
            </ul>

            <Button size="xl" className="w-full md:w-auto px-12 py-5 text-xl shadow-xl shadow-rose-500/40 animate-pulse-slow" data-id="element-155">
              ¡Comprar Ahora!
            </Button>
            <p className="text-sm text-gray-400 mt-2" data-id="element-156">
              Pago 100% seguro y encriptado
            </p>
          </div>

          {/* Guarantee Box */}
          <div className="bg-rose-50 rounded-2xl p-6 md:p-8 flex flex-col md:flex-row items-center gap-6 text-left border border-rose-100" data-id="element-157">
            <div className="bg-white p-4 rounded-full shadow-md shrink-0" data-id="element-158">
              <ShieldCheck className="w-10 h-10 text-rose-500" data-id="element-159" />
            </div>
            <div data-id="element-160">
              <h4 className="font-bold text-xl text-dark mb-2" data-id="element-161">
                Garantía de 30 días sin riesgo
              </h4>
              <p className="text-dark-light text-sm leading-relaxed" data-id="element-162">
                Probalo durante 30 días. Si en ese tiempo no aprendés las
                técnicas ni empezás a generar ingresos, podés pedir la
                devolución total de tu dinero. Sin preguntas. Porque la misión
                del programa es ayudarte a generar ingresos de manera rápida y
                efectiva.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}